var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root"},[_vm._t("default"),_vm._v(" "),_c('div',{ref:"observee",staticClass:"position-relative"},[(_vm.hasMoreItems)?_c('div',{staticClass:"mt-5 spinner-wrapper"},[_c('spinner',{staticClass:"spinner"})],1):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }